"use strict";

exports.__esModule = true;
exports.CreateCommentActionElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CreateCommentActionDialog = require("./CreateCommentActionDialog");
var _Translator = require("../../Core/Translator");
var _LogbookContext = require("../../Logbook/LogbookContext");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _DeviceContext = require("../../Device/DeviceContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Provides a function to a render prop which opens the commenting modal
 */
var CreateCommentActionElement = exports.CreateCommentActionElement = function CreateCommentActionElement(props) {
  var _useState = (0, _react.useState)(false),
    isDialogOpen = _useState[0],
    setIsDialogOpen = _useState[1];
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var toggleDialog = function toggleDialog() {
    setIsDialogOpen(!isDialogOpen);
  };
  var reportingPeriod = _react["default"].useContext(_ReportingPeriod.ReportingPeriodContext);
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var invoke = function invoke() {
    setIsDialogOpen(true);
  };
  var childProps = {
    invoke: invoke
  };
  if (!isDialogOpen) {
    return props.children(childProps);
  }
  var label = props.label || translate("CreateCommentActionDialog.title", "Create Comment");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_LogbookContext.LogbookContext.Provider, {
    device: device,
    interval: reportingPeriod.interval
  }, props.children(childProps), /*#__PURE__*/_react["default"].createElement(_CreateCommentActionDialog.CreateCommentActionDialog, {
    label: label,
    isOpen: isDialogOpen,
    toggleDialog: toggleDialog,
    defaultCommentID: props.defaultCommentID
  })));
};